// CANONICAL COPY (GH #7115). src/constants/obligations/obl-logging-review.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-logging-review',
  title: 'Review audit log configuration',
  description:
    'Verify that logging is enabled, log retention meets policy requirements, and log review processes are in place. Clocks of all relevant information processing systems shall be synchronised to approved time sources to ensure accuracy of log records and event correlation.',
  category: 'technical',
  scfIds: ['SCF-OPS-006', 'SCF-OPS-008'],
  cadence: { frequency: '6m', anchor: 'domain' },
  // SDEA-04: neither checker below vacuous-passes on zero tenant activity —
  // 'activity-log-configured' fails when retentionDays is unset/0, and
  // 'document-published' fails when no matching document exists — so 'any'
  // still requires real evidence from at least one of the two paths.
  strategy: 'any',
  fulfilmentCriteria: [
    { type: 'activity-log-configured', description: 'Activity log retention policy is configured' },
    { type: 'document-published', description: 'Logging policy is published' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
